import { connect } from "react-redux";
import DefaultLayout from "./default-layout";
import { onHamburgerClicked } from "../actions";
import { subscriptionFetch } from "features/account/actions";

const mapStateToProps = ({ frame, profile, subscription }) => ({
	openMobile: frame.navigation.isMobileOpen,
	role: profile.role,
	subscriptionStatus: subscription.subscriptionStatus,
});

const mapDispatchToProps = {
	onToggleSideNavBar: onHamburgerClicked,
	onFetchSubscriptionStatus: subscriptionFetch,
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);
